module.exports = __webpack_public_path__ + "image/new_banner.png";